import React from 'react';
import { ChevronRightIcon, CheckIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 md:pt-16 md:pb-14 overflow-hidden" data-id="element-529">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern z-0" data-id="element-530"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[120px] z-0 pointer-events-none" data-id="element-531"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-532">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-533">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-400 text-sm font-medium mb-5 tracking-wider uppercase" data-id="element-534">
            <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" data-id="element-535"></span>
            System Online
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight" data-id="element-536">
            FROM 60-HOUR CORPORATE GRIND TO A 4-HOUR{' '}
            <br className="hidden md:block" data-id="element-537" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 text-glow" data-id="element-538">
              "GHOST FACTORY"
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 mb-8 font-light" data-id="element-539">
            That Generates $10,000/Month While You Sleep.
          </p>

          {/* CTA Button */}
          <div className="flex flex-col items-center justify-center gap-6" data-id="element-540">
            <a href="#checkout" onClick={e => {
            e.preventDefault();
            document.getElementById('checkout')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-black bg-cyan-400 rounded-sm overflow-hidden transition-all hover:bg-cyan-300 hover:shadow-[0_0_30px_rgba(0,240,255,0.5)]" data-id="element-541">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-10" data-id="element-542"></span>
              <span className="relative flex items-center gap-2" data-id="element-543">
                INITIALIZE ENGINE — $27 <ChevronRightIcon className="w-5 h-5" data-id="element-544" />
              </span>
            </a>

            {/* WHAT YOU GET TODAY — Value Box */}
            <div className="w-full max-w-2xl bg-dark-900 border border-cyan-500/20 rounded-xl p-6 md:p-8 text-left" data-id="element-545">
              <h3 className="text-sm font-bold text-cyan-400 uppercase tracking-widest mb-5 text-center" data-id="element-546">
                What You Get Today
              </h3>

              <div className="space-y-4" data-id="element-547">
                <div className="flex items-start justify-between gap-4" data-id="element-548">
                  <div className="flex items-start gap-3" data-id="element-549">
                    <CheckIcon className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-550" />
                    <span className="text-white font-medium" data-id="element-551">
                      The $10K AI Content Engine{' '}
                      <span className="text-gray-500 font-normal" data-id="element-552">
                        (complete system)
                      </span>
                    </span>
                  </div>
                  <span className="text-gray-400 font-medium shrink-0" data-id="element-553">
                    $197
                  </span>
                </div>

                <div className="flex items-start justify-between gap-4" data-id="element-554">
                  <div className="flex items-start gap-3" data-id="element-555">
                    <CheckIcon className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-556" />
                    <div data-id="element-557">
                      <span className="text-white font-medium" data-id="element-558">
                        Bonus #1: 30-Min Offer Clarity Kit
                      </span>
                      <span className="ml-2 inline-block text-[10px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-559">
                        FREE
                      </span>
                      <p className="text-gray-500 text-sm mt-0.5" data-id="element-560">
                        Your $10K retainer defined in one sitting
                      </p>
                    </div>
                  </div>
                  <span className="text-gray-500 font-medium shrink-0 line-through" data-id="element-561">
                    $197
                  </span>
                </div>

                <div className="flex items-start justify-between gap-4" data-id="element-562">
                  <div className="flex items-start gap-3" data-id="element-563">
                    <CheckIcon className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-564" />
                    <div data-id="element-565">
                      <span className="text-white font-medium" data-id="element-566">
                        Bonus #2: Corporate-to-Creator Scripts
                      </span>
                      <span className="ml-2 inline-block text-[10px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-567">
                        FREE
                      </span>
                      <p className="text-gray-500 text-sm mt-0.5" data-id="element-568">
                        DMs, calls and objection killers to close $10K
                      </p>
                    </div>
                  </div>
                  <span className="text-gray-500 font-medium shrink-0 line-through" data-id="element-569">
                    $297
                  </span>
                </div>

                <div className="flex items-start justify-between gap-4" data-id="element-570">
                  <div className="flex items-start gap-3" data-id="element-571">
                    <CheckIcon className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" data-id="element-572" />
                    <div data-id="element-573">
                      <span className="text-white font-medium" data-id="element-574">
                        Bonus #3: 4-Hours/Week Execution Planner
                      </span>
                      <span className="ml-2 inline-block text-[10px] font-extrabold uppercase tracking-widest bg-cyan-400 text-black px-1.5 py-0.5 rounded align-middle" data-id="element-575">
                        FREE
                      </span>
                      <p className="text-gray-500 text-sm mt-0.5" data-id="element-576">
                        Execute without burnout, even with limited time
                      </p>
                    </div>
                  </div>
                  <span className="text-gray-500 font-medium shrink-0 line-through" data-id="element-577">
                    $97
                  </span>
                </div>
              </div>

              {/* Total */}
              <div className="mt-6 pt-5 border-t border-cyan-500/20 flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-578">
                <span className="text-gray-500 line-through text-lg" data-id="element-579">
                  Total Value: $788
                </span>
                <span className="text-2xl font-bold text-cyan-400 text-glow" data-id="element-580">
                  Your Investment: $27
                </span>
              </div>

              <p className="text-center text-sm text-gray-500 mt-3" data-id="element-581">
                One-time payment. Instant delivery. 30-day guarantee.
              </p>
            </div>

            {/* Price Justification */}
            <p className="max-w-xl text-sm text-gray-500 text-center leading-relaxed" data-id="element-582">
              <span className="text-gray-400 font-medium" data-id="element-583">Why $27?</span>{' '}
              Because the price should never be the barrier. The ROI from your
              first client ($2,500/month) makes $27 background noise.
            </p>

            {/* Guarantee Block */}
            <div className="w-full max-w-2xl bg-dark-900 border border-green-500/20 rounded-xl p-6" data-id="element-584">
              <div className="flex flex-col items-center text-center gap-3" data-id="element-585">
                <ShieldCheckIcon className="w-8 h-8 text-green-400" data-id="element-586" />
                <h4 className="text-sm font-bold text-white uppercase tracking-wide" data-id="element-587">
                  30-DAY FULL GUARANTEE
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed max-w-lg" data-id="element-588">
                  If in the next 30 days you don't have your offer defined, your
                  first scripts ready, and your system running — write to me.
                  I'll refund every cent. No forms. No awkward questions.
                </p>
                <p className="text-cyan-400 text-sm italic" data-id="element-589">
                  Why can I offer this? Because the people who implement this
                  don't ask for refunds.
                </p>
              </div>
            </div>

            {/* Urgency Line */}
            <p className="text-sm text-amber-400/80" data-id="element-590">
              Launch price: $27 — This price increases soon. Once it goes up, it
              doesn't come back down.
            </p>
          </div>
        </div>

        {/* Product Image */}
        <div className="relative max-w-4xl mx-auto mt-10" data-id="element-591">
          <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl blur opacity-30 animate-pulse" data-id="element-592"></div>
          <div className="relative rounded-xl overflow-hidden border border-cyan-500/20 bg-dark-900 p-2 shadow-2xl" data-id="element-593">
            <img src="https://cdn.magicpatterns.com/uploads/rkyG2UTAdxpsg9UVRM7F7u/THE_10K_IA_CONTENT.png" alt="The $10K AI Content Engine Product" className="w-full h-auto rounded-lg object-cover" data-id="element-594" />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-900/80 via-transparent to-transparent pointer-events-none" data-id="element-595"></div>
          </div>
        </div>
      </div>
    </section>;
}